import { useState } from "react"
import { useNavigate } from "react-router-dom"

import Style from "./style"

import useGetAdminEvent from "entity/event/useGetAdminEvent"
import useGetManagerEvent from "entity/event/useGetManagerEvent"

import useGetExternalAdminEvent from "entity/event/useGetExternalAdminEvent"
import logo from "shared/asset/logo.svg"
import { convertProGradeAsName, UNQUALIFIED } from "shared/constant/lookup/proGrade"
import { ROLE_EXTERNAL_ADMIN, ROLE_FRANCHISE_MANAGER, ROLE_STORE_MANAGER } from "shared/constant/lookup/role"
import timestampCalculator from "shared/lib/timestampCalculator"
import useAlertModalAtom from "shared/model/useAlertModalAtom"
import useLoginCookie from "shared/model/useLoginCookie"
import useRoleCookie from "shared/model/useRoleCookie"
import DefaultButton from "shared/ui/DefaultButton"

const SelectEvent = () => {
    const navigate = useNavigate()

    const [selectIdx, setSelectIdx] = useState()

    const [, , deleteLoginCookie] = useLoginCookie()
    const [roleCookie, , deleteRoleCookie] = useRoleCookie()
    const [, setAlert] = useAlertModalAtom()

    // 로그인 계정의 권한에 따라 백엔드 통신 후 매핑
    const [managerEventList] = useGetManagerEvent()
    const [adminEventList] = useGetAdminEvent()
    const [externalAdminEventList] = useGetExternalAdminEvent()

    const eventList = [ROLE_EXTERNAL_ADMIN].includes(roleCookie)
        ? externalAdminEventList?.data?.event_list 
        : [ROLE_FRANCHISE_MANAGER, ROLE_STORE_MANAGER].includes(roleCookie)
        ? managerEventList?.data?.event_list 
        : adminEventList?.data?.event_list 

    const selectEvent = () => {
        if (!selectIdx) {
            setAlert("대회를 선택해 주세요.")
        } else {
            navigate(`/event/${selectIdx}/timer`)
        }
    }

    const logoutEvent = () => {
        deleteLoginCookie()
        deleteRoleCookie()
        navigate('/')
    }

    return (
        <Style.Wrapper>
            <Style.ContentDiv>

                <Style.LogoImg src={logo} />

                <Style.ElemList>
                    {eventList?.map(elem =>
                        <Style.Elem onClick={() => setSelectIdx(elem.idx)} $select={elem.idx === selectIdx}>
                            <Style.ElemContent>
                                <h2>{elem?.name}</h2>
                                <p>{timestampCalculator(elem?.date)}</p>
                                <p>{elem?.pro_grade_flag === UNQUALIFIED ? "프로 자격 제한 없음" : `${convertProGradeAsName[elem?.pro_grade_flag]} 프로 이상 참가 가능`}</p>
                            </Style.ElemContent>
                            <p>{elem?.event_type}</p>
                        </Style.Elem >
                    )}
                </Style.ElemList>

                <Style.ButtonDiv>
                    <DefaultButton minor clickEvent={logoutEvent}>로그아웃</DefaultButton>
                    <DefaultButton clickEvent={selectEvent}>실행</DefaultButton>
                </Style.ButtonDiv>

            </Style.ContentDiv>
        </Style.Wrapper >
    )
}

export default SelectEvent